import React, { FC } from 'react'
import { Column } from '../../../models/column'
import useTableTranslation from '@components/UI-Components/HierarchyWiseItemsTable/hooks/use-table-translation'
import { stores } from '@stores'
import { CentricTypography as Typography } from '@core/component/CentricTypography'

export interface CellProps {
  column?: Column
  customClass?: any
}

const HeaderCell: FC<CellProps> = ({ column }) => {
  const { label, key } = column
  const {
    productConfiguration: { enhancedViewEnabled }
  } = stores
  const { t } = useTableTranslation()
  const colHeader = key ? t(`order.listview.colHeader.${key}`, label) : label
  return (
    <>
      {enhancedViewEnabled ? (
        <Typography variant='subtitle2DarkGrey'>{colHeader}</Typography>
      ) : (
        colHeader
      )}
    </>
  )
}

export default HeaderCell
